import axios from 'axios';

axios.defaults.withCredentials = false;
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';

export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3000';